<template>
    <ConfirmationForm
        :type="AssortmentType.ServerDeals"
        :price="monthlyPrice"
        :setup-price="setupPrice"
        :configuration="mailSummary"
        :selection="selection"
        :redirect-params="`?redirect=dedicated-server-mieten/confirm&query=${queryParams}`"
    />
</template>

<script setup>
import ConfirmationForm from './ConfirmationForm.vue';
import { getQueryParams } from '../../../utils/windowUtils';
import { useAssortmentSpecialDeal } from '../composables/assortmentSpecialDeal';
import { AssortmentType } from '../../../types';
import { onMounted } from 'vue';
import { pushToGoogleTagManager } from '../../../utils/googleTagManagerUtils';

const props = defineProps({
    assortmentContent: { type: String, default: '' },
    assortmentNetworkContent: { type: String, default: '' },
    assortmentIpContent: { type: String, default: '' },
});

const queryParams = getQueryParams('|');
const { monthlyPrice, setupPrice, mailSummary, selection } = useAssortmentSpecialDeal(
    props.assortmentContent,
    props.assortmentNetworkContent,
    props.assortmentIpContent
);

onMounted(() => {
    pushToGoogleTagManager({
        event: `${AssortmentType.ServerDeals.toLowerCase()}-config-page-1-continue`,
        conversionValue: monthlyPrice.value,
    });
});
</script>
